var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Select as ChakraSelect, useColorModeValue, useTheme, } from "@chakra-ui/react";
import { Size, Variant, ColorScheme, pick, transparentize, } from "../../core";
import FormControl from "../FormControl";
export const SelectSize = pick(Size, ["sm", "md", "lg"]);
export const SelectVariant = pick(Variant, [
    "outline",
    "filled",
    "flushed",
    "unstyled",
    "ghost",
]);
/**
 * Select component is a component that allows users pick a value from predefined options.
 * Ideally, it should be used when there are more than 5 options, otherwise you might consider using a radio group instead.
 */
const Select = forwardRef((props, ref) => {
    var _a;
    const { className, variantColor, colorScheme, options, children, label, name, error, helper, size } = props, rest = __rest(props, ["className", "variantColor", "colorScheme", "options", "children", "label", "name", "error", "helper", "size"]);
    const scheme = colorScheme !== null && colorScheme !== void 0 ? colorScheme : variantColor;
    const theme = useTheme();
    const focusBorderColor = useColorModeValue(`${scheme}.500`, transparentize(`${scheme}.700`, 0.5)(theme));
    const errorBorderColor = useColorModeValue(`${ColorScheme.error}.500`, transparentize(`${ColorScheme.error}.200`, 0.5)(theme));
    return (React.createElement(FormControl, { name: name, label: label, error: error, helper: helper, size: size },
        React.createElement(ChakraSelect, Object.assign({}, rest, { ref: ref, name: name, size: size, focusBorderColor: focusBorderColor, errorBorderColor: errorBorderColor, className: className, colorScheme: scheme }), (_a = options === null || options === void 0 ? void 0 : options.map(({ label: selectLabel, value }) => (React.createElement("option", { value: value, key: selectLabel }, selectLabel)))) !== null && _a !== void 0 ? _a : children)));
});
Select.displayName = "Select";
export default Select;
//# sourceMappingURL=Select.js.map